import type { TranslationMessages } from '../types';

export const customers: TranslationMessages = {
  name: 'Customer |||| Customers',
  title: 'Customers',
  create: 'Create Customer',
  edit: 'Edit Customer',
  create_description: 'Create a new customer account',
  edit_description: 'Update customer information',
  fields: {
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    city: 'City',
    stateAbbr: 'State/Province',
    zipcode: 'Zip Code',
    birthday: 'Birthday',
    totalSpent: 'Total Spent',
    nbCommands: 'Orders',
    lastSeen: 'Last Seen',
    orders: 'Orders',
    first_seen: 'First Seen',
    groups: 'Groups',
    last_seen: 'Last Seen',
    last_seen_gte: 'Visited Since',
    name: 'Name',
    total_spent: 'Total Spent',
    password: 'Password',
    confirm_password: 'Confirm Password',
    customerPoints: 'Points: %{points}',
    otp: 'OTP Code',
  },
  filters: {
    last_visited: 'Last Visit',
    today: 'Today',
    this_week: 'This Week',
    last_week: 'Last Week',
    this_month: 'This Month',
    last_month: 'Last Month',
    earlier: 'Earlier',
    has_ordered: 'Has Ordered',
    has_newsletter: 'Newsletter Subscribed',
    group: 'Group',
  },
  fieldGroups: {
    identity: 'Personal Information',
    address: 'Address',
    stats: 'Statistics',
    history: 'History',
    password: 'Password',
    change_password: 'Change Password',
  },
  page: {
    delete: 'Delete Customer',
    showing: 'Showing',
    to: 'to',
    of: 'of',
    page: 'Page',
    customers: 'customers',
  },
  errors: {
    password_mismatch: 'Password confirmation does not match password.',
  },
  actions: {
    verifyOtp: 'Verify OTP',
  },
};
